export class User {
	id: number;
	userName: string;
	username: string;
	firstName: string;
	lastName: string;
	NIT: string;
	DUI: string;
	phone: string;
	address: string;
	email: string;
	password: string;
	roles: Array<any>;
}